import { ReactNode } from "react";
import PedidosIcon from "../../../../assets/icons/dashboard/pedidos.png";
import CaixaIcon from "../../../../assets/icons/dashboard/caixa.png";
import DesempenhoIcon from "../../../../assets/icons/dashboard/desempenho.png";
import HistoricoIcon from "../../../../assets/icons/dashboard/historico.png";
import MinhaEmpresaIcon from "../../../../assets/icons/dashboard/minha_empresa.png";
import CatalogoIcon from "../../../../assets/icons/dashboard/catalogo.png";
//import CatalogoIcon from "../../../assets/icons/dashboard/catalogo.png";
import FinanceiroIcon from "../../../../assets/icons/dashboard/financeiro.png";
import EstoqueIcon from "../../../../assets/icons/dashboard/estoque.png";
import DeliveryIcon from "../../../../assets/icons/dashboard/delivery.png";
import CupomIcon from "../../../../assets/icons/dashboard/cupom.png";
import ConfigIcon from "../../../../assets/icons/dashboard/config.png";

export interface SidebarMenuProps {
  label: string;
  path: string;
  //icon?: ComponentType<SVGProps<SVGSVGElement>>;
  icon?: ReactNode;
  requiredPermission?: string; // Nova propriedade
  adminOnly?: boolean;
  //icon?: ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const sidebarMenu: SidebarMenuProps[] = [
  {
    label: "Gestão de pedidos",
    path: "/pedidos",
    icon: PedidosIcon,
    requiredPermission: "SCOPE_PEDIDO"
  },
  /*
  {
    label: "KDS",
    path: "/kds",
    icon: KdsIcon
    // children: [
    //   { label: "Tela", path: "/kds" },
    //   { label: "Histórico", path: "/kds/historico" },
    // ],
  },
  */
  {
    label: "Caixa",
    path: "/caixa",
    icon: CaixaIcon,
    // children: [
    //   { label: "Abertura", path: "/caixa" },
    //   { label: "Fechamento", path: "/caixa/fechamento" },
    // ],
    requiredPermission: "SCOPE_CAIXA"
  },
  {
    label: "Desempenho",
    path: "/desempenho",
    icon: DesempenhoIcon,
    // children: [
    //   { label: "Abertura", path: "/caixa" },
    //   { label: "Fechamento", path: "/caixa/fechamento" },
    // ],
    requiredPermission: "SCOPE_DASHBOARD"
  },
  // {
  //   label: "Histórico",
  //   path: "/historico",
  //   icon: HistoricoIcon
  //   // children: [
  //   //   { label: "Abertura", path: "/caixa" },
  //   //   { label: "Fechamento", path: "/caixa/fechamento" },
  //   // ],
  // },
  {
    label: "Minha Empresa",
    path: "/minhaempresa",
    icon: MinhaEmpresaIcon,
    adminOnly: true // Exemplo: só DONO ou GERENTE vê
    // children: [
    //   { label: "Abertura", path: "/caixa" },
    //   { label: "Fechamento", path: "/caixa/fechamento" },
    // ],
  },
  {
    label: "Catálogo",
    path: "/catalogo",
    icon: CatalogoIcon,
    requiredPermission: "SCOPE_CATALOGO"
    // children: [
    //   { label: "Abertura", path: "/caixa" },
    //   { label: "Fechamento", path: "/caixa/fechamento" },
    // ],
  },
  {
    label: "Financeiro",
    path: "/financeiro",
    icon: FinanceiroIcon,
    requiredPermission: "SCOPE_FINANCEIRO"
    // children: [
    //   { label: "Abertura", path: "/caixa" },
    //   { label: "Fechamento", path: "/caixa/fechamento" },
    // ],
  },
  // {
  //   label: "Estoque",
  //   path: "/estoque",
  //   icon: EstoqueIcon
  //   // children: [
  //   //   { label: "Abertura", path: "/caixa" },
  //   //   { label: "Fechamento", path: "/caixa/fechamento" },
  //   // ],
  // },
  {
    label: "Delivery",
    path: "/delivery",
    icon: DeliveryIcon,
    requiredPermission: "SCOPE_DELIVERY"
    // children: [
    //   { label: "Abertura", path: "/caixa" },
    //   { label: "Fechamento", path: "/caixa/fechamento" },
    // ],
  },
  {
    label: "Cupons",
    path: "/cupons",
    icon: CupomIcon,
    requiredPermission: "SCOPE_CUPONS"
    // children: [
    //   { label: "Abertura", path: "/caixa" },
    //   { label: "Fechamento", path: "/caixa/fechamento" },
    // ],
  },
  {
    label: "Configurações",
    path: "/configuracao",
    icon: ConfigIcon,
    requiredPermission: "SCOPE_CONFIGURACAO"
    // children: [
    //   { label: "Abertura", path: "/caixa" },
    //   { label: "Fechamento", path: "/caixa/fechamento" },
    // ],
  },
];